export const ParametersPage = () => <p>Hello from parameters page</p>;
